import { compose } from 'react-apollo';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';

import {withRouter} from 'react-router';

import CallsList from './CallsList.js';

export default compose(
  withRouter,
  graphql(gql`query {
    calls{
      id,
      date,
      phone,
      duration,
      agent_extension,
      ended,
      answered,
      call_type,
      client {
        id,
        name,
        leads {
          id,
          remonline_data,
          remonline_id,
          act_number,
          device_type_id,
          problem_type_id,
          status_id,
          model,
          comment,
          created_at,
          first_call_by_id,
          created_by_id,
          confirmed_by_id,
        }
        
      }
    }
  }`, {
    options: {
      pollInterval: 4000
    },
  }),
)(CallsList);